import type { RefObject } from "react";
import { LEGAL_COMPLIANCE_COPY } from "@/features/legal/config/legal.config";
import type { LegalCompliance } from "@/features/legal/types/legalCompliance.type";

type LegalComplianceHeaderProps = {
  headingRef: RefObject<HTMLHeadingElement | null>
  legalCompliance: LegalCompliance
};

export const LegalComplianceHeader = ({ headingRef, legalCompliance }: LegalComplianceHeaderProps) => {
  const isFirstAcceptance = !legalCompliance.previously_accepted;

  return (
    <div className="space-y-3 text-left">
      <h1
        ref={headingRef}
        tabIndex={-1}
        className="text-3xl font-bold leading-tight tracking-tight text-gray-900 outline-none dark:text-white"
      >
        {isFirstAcceptance ? LEGAL_COMPLIANCE_COPY.TITLE : LEGAL_COMPLIANCE_COPY.UPDATE_TITLE}
      </h1>
      <p className="text-base leading-7 text-gray-600 dark:text-gray-300">
        {isFirstAcceptance ? LEGAL_COMPLIANCE_COPY.FIRST_ACCEPTANCE_INTRO : LEGAL_COMPLIANCE_COPY.UPDATE_INTRO}
      </p>
      {!isFirstAcceptance && legalCompliance.change_summary && (
        <p className="text-base text-gray-600 dark:text-gray-300">
          <span className="font-semibold text-gray-900 dark:text-white">{LEGAL_COMPLIANCE_COPY.CHANGE_SUMMARY_PREFIX}</span>
          {" "}
          {legalCompliance.change_summary}
        </p>
      )}
    </div>
  );
};
